import React from 'react'
import DeleteConfirmationDialog from './DeleteConfirmationPopup';

const UnsavedChangesPopup = ({ open, handleClose = () => { }, handleSubmission = () => { } }) => {
    return (
        <DeleteConfirmationDialog
            open={open}
            handleClose={handleClose}
            heading={"Unsaved Changes"}
            subheading={"You have unsaved changes. Closing now will discard these changes."}
            handleSubmission={handleSubmission}
            ActionText={"Discard Changes"}
            CancelText={"Continue Editing"}
            invertActions={true}
            key={"Unsaved Changes"}
        />
    )
}

export default UnsavedChangesPopup